import QueryHaving from '~/scripts/services/model/query-having';

export default class QueryRule {
	/**
	 * @param {any} rule
	 */
	constructor(rule = null) {
		/** @type {string | undefined} */
		this.attribut = rule?.attribut || undefined;

		/** @type {'AND' | 'OR' } */
		this.condition = rule?.condition || 'AND';

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.id = rule?.id || undefined;

		/** @type {import('@knitiv/api-client-javascript').KNode | string | undefined} */
		this.field = rule?.field || undefined;

		/** @type {string | undefined} */
		this.label = rule?.label || undefined;

		/** @type {import('@knitiv/api-client-javascript').TypeKid | undefined} */
		this.type = rule?.type || undefined;

		/** @type {any[]} */
		this.path = rule?.path || [];

		/** @type {import('./query-having').default | undefined} */
		this.having = rule?.having ? new QueryHaving(rule.having) : undefined;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.lang_kid = rule?.lang_kid || undefined;

		/** @type {import('@knitiv/api-client-javascript').LinkerKNode | undefined} */
		this.linker_kid = rule?.linker_kid || undefined;

		/** @type {import('@knitiv/api-client-javascript').LinkerInfoValidator<any> | undefined} */
		this.linker_info = rule?.linker_info || undefined;

		/** @type {string | undefined} */
		this.operator = rule?.operator || undefined;

		/** @type {QueryRule[] | undefined} */
		this.rules = rule?.rules || undefined;

		/** @type {any} */
		this.value = rule?.value || undefined;

		/** @type {string | undefined} */
		this.variable = rule?.variable || undefined;
	}

	isDateRange() {
		return this.type === 'K_NODE;DATE'
			&& (
				this.value?.unit !== undefined
				|| (Array.isArray(this.value) && this.value.length > 0 && this.value[0]?.unit !== undefined)
			);
	}
}
